"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const luxon_1 = require("luxon");
class Period {
    constructor({ from, to }) {
        this.toJSON = () => ({
            from: this.from,
            to: this.to,
        });
        this.from = from;
        this.to = to;
    }
}
Period.fromJSON = (json) => {
    const { from, to } = Object.assign({}, json);
    if (typeof from !== 'string')
        throw new Error('.from must be a string');
    if (typeof to !== 'string')
        throw new Error('.to must be a string');
    return new Period({
        from: luxon_1.DateTime.fromISO(from),
        to: luxon_1.DateTime.fromISO(to),
    });
};
exports.default = Period;
